import SingleSelectComponent from "../../../../components/SingleSelect";


/**
 * Renders the glucometer question asking whether the user has a CGM or finger-prick glucose monitor.
 * 
 * @param show_glucometer_question - Whether to display the question.
 * @param provide_glucometer_option - Whether to show the option to request a CGM.
 * @param finger_prick_option - Whether to allow using a finger-prick monitor.
 * @param glucometerValue - The current selected value.
 * @param setGlucometerValue - Callback to update the selected value.
 * @param validGlucometer - Whether the selected value is valid (used for showing validation message).
 * 
 * @returns JSX element or null
 */
function renderGlucometerQuestion(
    show_glucometer_question: boolean,
    provide_glucometer_option: boolean,
    finger_prick_option: boolean,
    glucometerValue: string,
    setGlucometerValue: (value: string) => void,
    validGlucometer: boolean
): JSX.Element | null {
    const glucometerOptions = [
        { value: 'FreeStyle Libre', label: 'Yes, I will use my FreeStyle Libre CGM', show: true },
        { value: 'Dexcom', label: 'Yes, I will use my Dexcom CGM', show: true },
        { value: 'Manual', label: 'Yes, I will use my finger-prick glucose monitor', show: finger_prick_option },
        {
            value: 'No',
            label: 'No, please send me a FreeStyle Libre or Dexcom CGM',
            show: provide_glucometer_option
        }
    ]
    const glucometerQuestion: JSX.Element = <SingleSelectComponent
        question={
            finger_prick_option
                ? "Do you have a continuous glucose monitor (CGM) or a finger-prick glucose monitor that you will use for the program?"
                : "Do you have a continuous glucose monitor (CGM) that you will use for the program?"
        }
        options={glucometerOptions}
        value={glucometerValue}
        onChange={setGlucometerValue}
        showMessage={!validGlucometer}
    />;
    if (show_glucometer_question) {
        return glucometerQuestion
    } else {
        return null
    }
}

export default renderGlucometerQuestion;